import Bottega from './megaMenuImages/Bottega.png';
import bags_EL from './megaMenuImages/bags_EL.png';
import bags_EN from './megaMenuImages/bags_EN.png';
import wallets_EL from './megaMenuImages/wallets_EL.png';
import wallets_EN from './megaMenuImages/WALLETS_EN.png';
import image3 from './megaMenuImages/test.jpg';
import gucci_portrait from './megaMenuImages/gucci_portrait.png';
import JEWELRY_EL from './megaMenuImages/JEWELRY_EL.png';
import JEWELRY_EN from './megaMenuImages/JEWELRY_EN.png';
import we_are_pop_nouvelle from './megaMenuImages/we_are_pop_nouvelle.png';
import P from './megaMenuImages/P.png';
const traverse = require('traverse');
import { languageType } from './util/languageType';
import { getLocalizedPipeValue } from './util/locales';
import { stubFalse } from 'lodash';

// {
//   main: {
//     label: 'New In',
//     url: '',
//   },
//   column: [
//     {
//       title: '',
//       sub: [],
//     },
//   ],
//   clickable: false,
//   hoverable: false,
// },
const megaMenu = [
  {
    main: {
      label: 'New In|Νέες Αφίξεις|Novedades',
      url: '/s/all_products?pub_department=women',
    },
    column: [],
    clickable: true,
    hoverable: false,
  },
  {
    main: {
      label: 'Top Brands|Top Brands|Marcas Destacadas',
      url: ' ',
    },
    column: [
      {
        title: '',
        sub: [
          {
            label: 'Louis Vuitton|Louis Vuitton|Louis Vuitton',
            url: '/s/all_products?pub_department=women&pub_designer=louisVuitton',
          },
           {
            label: 'Chanel|Chanel|Chanel',
            url: '/s/all_products?pub_department=women&pub_designer=chanel',
          },
          {
            label: 'Gucci|Gucci|Gucci',
            url: '/s/all_products?pub_department=women&pub_designer=gucci',
          },
          {
            label: 'Fendi|Fendi|Fendi',
            url: '/s/all_products?pub_department=women&pub_designer=fendi',
          },
          {
            label: 'Bottega Veneta|Bottega Veneta|Bottega Veneta',
            url: '/s/all_products?pub_department=women&pub_designer=bottegaVeneta',
          },
          {
            label: 'Dior|Dior|Dior',
            url: '/s/all_products?pub_department=women&pub_designer=dior',
          },
          {
            label: 'Hermès|Hermès|Hermès',
            url: '/s/all_products?pub_department=women&pub_designer=hermes',
          }, 
          {
            label: 'Saint Laurent|Saint Laurent|Saint Laurent',
            url: '/s/all_products?pub_department=women&pub_designer=saintLaurent',
          },  
        ],
      },
    ],

    clickable: false,
    hoverable: true,
    image: {
      height: '300px',
      width: '300px',
      imageUrl: Bottega,
      elImageUrl: Bottega,
      url: '/s/all_products?pub_department=women&pub_designer=bottegaVeneta',
    },
  },

  {
    main: {
      label: 'Bags|Τσάντες|Bolsos',
      url: '/s?pub_category=bags&pub_department=women',
    },
    column: [
      {
        title: 'Categories|Κατηγορίες|Categorías',
        sub: [
          {
            label: 'All bags|Όλες οι τσάντες|Todos los bolsos',
            url: '/s?pub_category=bags&pub_department=women',
          },
          {
            label: 'Handbags|Τσάντες Χειρός|Bolsos de mano',
            url: '/s?pub_category=bags&pub_department=women&pub_subCategory=handbags',
          },
          {
            label: 'Clutch bags|Τσάντες Clutch|Clutches',
            url: '/s?pub_category=bags&pub_department=women&pub_subCategory=clutchbags',
          },
          {
            label: 'Tote bags|Τσάντες Tote|Bolsos tote',
            url: '/s?pub_category=bags&pub_department=women&pub_subCategory=totebags',
          },
          {
            label: 'Backpacks|Σακίδια|Mochilas',
            url: '/s?pub_category=bags&pub_department=women&pub_subCategory=backpacks',
          },
          {
            label: 'Travelbags|Τσάντες Ταξιδιού|Bolsos de viaje',
            url: '/s?pub_category=bags&pub_department=women&pub_subCategory=travelbags',
          },
        ],
      },
      {
        title: 'Top Brands|Top Brands|Marcas Destacadas',
        sub: [
          {
            label: 'Louis Vuitton|Louis Vuitton|Louis Vuitton',
            url: '/s?pub_category=bags&pub_department=women&pub_designer=louisVuitton',
          },
          {
            label: 'Chanel|Chanel|Chanel',
            url: '/s?pub_category=bags&pub_department=women&pub_designer=chanel',
          },
          {
            label: 'Gucci|Gucci|Gucci',
            url: '/s?pub_category=bags&pub_department=women&pub_designer=gucci',
          },
          {
            label: 'Fendi|Fendi|Fendi',
            url: '/s?pub_category=bags&pub_department=women&pub_designer=fendi',
          },
          {
            label: 'Bottega Veneta|Bottega Veneta|Bottega Veneta',
            url: '/s?pub_category=bags&pub_department=women&pub_designer=bottegaVeneta',
          },
          {
            label: 'Dior|Dior|Dior',
            url: '/s?pub_category=bags&pub_department=women&pub_designer=dior',
          },
          {
            label: 'Hermès|Hermès|Hermès',
            url: '/s?pub_category=bags&pub_department=women&pub_designer=hermes',
          },
        ],
      },
    ],

    clickable: true,
    hoverable: true,
    image: {
      height: '300px',
      width: '300px',
      imageUrl: bags_EN,
      elImageUrl: bags_EL,
      url: '/s?price=0%2C1000&pub_category=bags&pub_department=women',
    },
  },

  {
    main: {
      label: 'Accessories|Αξεσουάρ|Accesorios',
      url: '/s?pub_category=accessories&pub_department=women',
    },
    column: [
      {
        title: 'Categories|Κατηγορίες|Categorías',
        sub: [
          {
            label: 'All accessories|Όλα τα αξεσουάρ|Todos los accesorios',
            url: '/s?pub_category=accessories&pub_department=women',
          },
          {
            label: 'Wallets|Πορτοφόλια|Carteras',
            url: '/s?pub_category=accessories&pub_department=women&pub_subCategory=wallets',
          },
          {
            label: 'Belts|Ζώνες|Cinturones',
            url: '/s?pub_category=accessories&pub_department=women&pub_subCategory=belts',
          },
          {
            label: 'Scarves|Μαντήλια|Bufandas',
            url: '/s?pub_category=accessories&pub_department=women&pub_subCategory=scarf',
          },
          {
            label: 'Sunglasses|Γυαλιά Hλίου|Gafas de sol',
            url: '/s?pub_category=accessories&pub_department=women&pub_subCategory=sunglasses',
          },
          {
            label: 'Hats & Beanies|Καπέλα & Σκουφάκια|Sombreros y gorros',
            url: '/s?pub_category=accessories&pub_department=women&pub_subCategory=hats',
          },
          {
            label: 'Hair Accessories|Αξεσουάρ Mαλλιών|Accesorios para el pelo',
            url: '/s?pub_category=accessories&pub_department=women&pub_subCategory=hair',
          },
          {
            label: 'Bag Accessories|Αξεσουάρ Τσάντας|Accesorios para bolsos',
            url: '/s?pub_category=accessories&pub_department=women&pub_subCategory=bag',
          },
          {
            label: 'Agenda Covers|Ατζέντες|Fundas de agenda',
            url: '/s?pub_category=accessories&pub_department=women&pub_subCategory=agenda',
          },
        ],
      },
      {
        title: 'Top Brands|Top Brands|Marcas Destacadas',
        sub: [
          {
            label: 'Louis Vuitton|Louis Vuitton|Louis Vuitton',
            url: '/s?pub_category=accessories&pub_department=women&pub_designer=louisVuitton',
          },
          {
            label: 'Gucci|Gucci|Gucci',
            url: '/s?pub_category=accessories&pub_department=women&pub_designer=gucci',
          },
          {
            label: 'Hermès|Hermès|Hermès',
            url: '/s?pub_category=accessories&pub_department=women&pub_designer=hermes',
          },
          {
            label: 'Chanel|Chanel|Chanel',
            url: '/s?pub_category=accessories&pub_department=women&pub_designer=chanel',
          },
          {
            label: 'Bottega Veneta|Bottega Veneta|Bottega Veneta',
            url: '/s?pub_category=accessories&pub_department=women&pub_designer=bottegaVeneta',
          },
        ],
      },
    ],

    clickable: true,
    hoverable: true,
    image: {
      height: '300px',
      width: '300px',
      imageUrl: wallets_EN,
      elImageUrl: wallets_EL,
      url: '/s?pub_category=accessories&pub_department=women&pub_subCategory=wallets',
    },
  },
  {
    main: {
      label: 'Jewelry|Κοσμήματα|Joyas',
      url: '/s?pub_category=jewelry&pub_department=women',
    },
    column: [
      {
        title: 'Categories|Κατηγορίες|Categorías',
        sub: [
          {
            label: 'All jewelry|Όλα τα κοσμήματα|Todas las joyas',
            url: '/s?pub_category=jewelry&pub_department=women',
          },
          {
            label: 'Bracelets|Βραχιόλια|Pulseras',
            url: '/s?pub_category=jewelry&pub_department=women&pub_subCategory=bracelet',
          },
          {
            label: 'Earrings|Σκουλαρίκια|Pendientes',
            url: '/s?pub_category=jewelry&pub_department=women&pub_subCategory=earring',
          },
          {
            label: 'Necklaces|Κολιέ|Collares',
            url: '/s?pub_category=jewelry&pub_department=women&pub_subCategory=necklace',
          },
          {
            label: 'Rings|Δαχτυλίδια|Anillos',
            url: '/s?pub_category=jewelry&pub_department=women&pub_subCategory=ring',
          },
          {
            label: 'Watches|Ρολόγια|Relojes',
            url: '/s?pub_category=jewelry&pub_department=women&pub_subCategory=watch',
          },
        ],
      },
      {
        title: 'Top Brands|Top Brands|Marcas Destacadas',
        sub: [
          {
            label: 'Cartier|Cartier|Cartier',
            url: '/s?pub_category=jewelry&pub_department=women&pub_designer=cartier',
          },
          {
            label: 'Bulgari|Bulgari|Bulgari',
            url: '/s?pub_category=jewelry&pub_department=women&pub_designer=bulgari',
          },
          {
            label: 'Tiffany & Co|Tiffany & Co|Tiffany & Co',
            url: '/s?pub_category=jewelry&pub_department=women&pub_designer=tiffanyCo',
          },
          {
            label: 'Chanel|Chanel|Chanel',
            url: '/s?pub_category=jewelry&pub_department=women&pub_designer=chanel',
          },
        ],
      },
    ],
    clickable: true,
    hoverable: true,
    image: {
      height: '300px',
      width: '300px',
      imageUrl: JEWELRY_EN,
      elImageUrl: JEWELRY_EL,
      url: '/s?pub_category=jewelry&pub_department=women',
    },
  },
  {
    main: {
      label: 'Clothing|Ρούχα|Ropa',
      url: '/s?pub_category=clothing&pub_department=women',
    },
    column: [],

    clickable: true,
    hoverable: false,
    image: {
      height: '300px',
      width: '300px',
      imageUrl: Bottega,
      elImageUrl: Bottega,
      url: '/s?pub_category=clothing&pub_department=women',
    },
  },
  {
    main: {
      label: 'Shoes|Παπούτσια|Zapatos',
      url: '/s?pub_category=shoes&pub_department=women',
    },
    column: [],

    clickable: true,
    hoverable: false,
    image: {
      height: '300px',
      width: '300px',
      imageUrl: Bottega,
      elImageUrl: Bottega,
      url: '/s?pub_category=shoes&pub_department=women',
    },
  },
  {
    main: {
      label: 'Inside Pop Nouvelle|Σχετικά με το Pop Nouvelle|Descubre Pop Nouvelle',
      url: ' ',
    },
    column: [
      {
        title: '',
        sub: [
          {
            label: 'About us|Σχετικά με εμάς|Quiénes somos',
            url: '/p/about',
          },
          {
            label: 'Authenticity and Quality Control|Έλεγχος Αυθεντικότητας & Ποιότητας|Autenticidad y Control de Calidad',
            url: '/p/authentication_service',
          },
          {
            label: 'Sustainability|Βιωσιμότητα|Sostenibilidad',
            url: '/p/sustainability_manifesto',
          },
          {
            label: 'Personal Shopping Service|Personal Shopping|Servicio de Personal Shopping',
            url: '/p/personal_shopping',
          },
        ],
      },
    ],

    clickable: false,
    hoverable: true,
    image: {
      height: '300px',
      width: '300px',
      imageUrl: we_are_pop_nouvelle,
      elImageUrl: we_are_pop_nouvelle,
      url: '/p/about',
    },
  },
  {
    main: {
      label: 'Dora Kats Closet|Dora Kats Closet|Dora Kats Closet',
      url: '/DoraKats',
    },
    column: [],
    clickable: true,
    hoverable: false,
  },
  {
    main: {
      label: 'Offers|Offers',
      url: '/sale26',
    },
    column: [],
    clickable: true,
    hoverable: false,
  },
];

const getMegaMenuData = lang => {
  const megaMenuData = JSON.parse(JSON.stringify(megaMenu));

  traverse(megaMenuData).forEach(function(_) {
    if (_['label']) {
      _['label'] = getLocalizedPipeValue(_['label'], lang);
    }

    if (_['title']) {
      _['title'] = getLocalizedPipeValue(_['title'], lang);
    }
  });

  return megaMenuData;
};

export { getMegaMenuData };
